import { RepaymentStrategy as Domain, RepaymentStrategyField } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { RepaymentStrategy as API } from 'modules/cm/api/cases/repaymentStrategy/RepaymentStrategy';
import * as propertyMapper from '../property/mapper';
import * as endowmentMapper from '../endowment/mapper';
import * as investmentMapper from '../investment/mapper';

const apiToDomain = (api: API): Domain => ({
  [RepaymentStrategyField.HaveEndownments]: Boolean(api.endowments.length),
  [RepaymentStrategyField.HaveInvestments]: Boolean(api.investments.length),
  [RepaymentStrategyField.HaveOther]: Boolean(api.hasOtherRepayments),
  [RepaymentStrategyField.HaveSaleOfAnotherProperty]: Boolean(api.properties.length),
  [RepaymentStrategyField.HaveSaleOfPropertyAndDownsizing]: Boolean(api.hasPropertyToSaleForDownsizing),

  [RepaymentStrategyField.RepaymentValueOfHaveSaleOfAnotherProperty]: api.anotherPropertyRepaymentValue || 0,
  [RepaymentStrategyField.RepaymentValueOfSaleOfPropertyAndDownsizing]: api.saleForDownsizingValue || 0,
  [RepaymentStrategyField.RepaymentValueOfHaveEndownments]: api.endowmentsTotalRepayment || 0,
  [RepaymentStrategyField.RepaymentValueOfHaveInvestments]: api.investmentsTotalRepayment || 0,
  [RepaymentStrategyField.RepaymentValueOfHaveOther]: api.otherTotalRepayment || 0,
  [RepaymentStrategyField.DetailsForOther]: api.otherRepaymentsDetails || '',

  [RepaymentStrategyField.TotalAmountToBeRepaid]: api.totalAmountToBeRepaid || 0,
  [RepaymentStrategyField.RepaymentValueTotalCalculated]: api.repaymentStrategyTotal || 0,

  properties: api.properties.map(propertyMapper.apiToDomain),
  endowments: api.endowments.map(endowmentMapper.apiToDomain),
  investments: api.investments.map(investmentMapper.apiToDomain),
});

export default apiToDomain;
